import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LocalMall } from "@mui/icons-material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import "./ProductCard.css";
import NotFoundImage from "./../assets/images/not-found-image.jpg";

const ProductCard = ({ product = {} }) => {
  const navigate = useNavigate();

  const handleReadMoreClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling to the parent Link
    navigate(`/product/${product.id}`);
  };

  return (
    <Link to={`/product/${product.id}`} className="text-decoration-none text-dark">
      <div className="product-card card shadow-sm">
        <div className="product-image-container">
          <img
            src={product.imageUrls || NotFoundImage}
            className="product-image"
            alt={product.name || "Product Image"}
          />
        </div>
        <div className="card-body">
          <h6 className="card-title text-truncate">{product.name || "Unnamed Product"}</h6>

          {/* Description with limited lines and "read more" */}
          <div className="description-container">
            <p className="card-text text-muted">
              {product.description || "No description available"}
            </p>
            <button onClick={handleReadMoreClick} className="read-more-link">
              .... read more
            </button>
          </div>

          <div className="d-flex align-items-center">
            <span className="text-warning me-2">⭐ {product.rating || "N/A"}</span>
            <span className="text-muted">({product.reviews || "0"} Reviews)</span>
          </div>

          <div className="d-flex align-items-center my-2">
            <h5 className="text-success me-2">₹{product.price}</h5>
            {product.originalPrice && (
              <>
                <h6 className="text-muted text-decoration-line-through">₹{product.originalPrice}</h6>
                <span className="ms-2 text-danger">
                  {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% off
                </span>
              </>
            )}
          </div>

          {/* Buttons with Icons */}
          <div className="d-flex justify-content-between mt-2">
            <button className="btn btn-outline-primary">
              <AddShoppingCartIcon />
            </button>
            <button className="btn btn-success">
              <LocalMall />
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;